var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0.5H6C4.3125 0.5 3 1.85938 3 3.5V5H1.125C0.46875 5 0 5.51562 0 6.125C0 6.78125 0.46875 7.25 1.125 7.25H3V11.375H1.125C0.46875 11.375 0 11.8906 0 12.5C0 13.1562 0.46875 13.625 1.125 13.625H3V17.75H1.125C0.46875 17.75 0 18.2656 0 18.875C0 19.5312 0.46875 20 1.125 20H3V21.5C3 23.1875 4.3125 24.5 6 24.5H19.5C21.1406 24.5 22.5 23.1875 22.5 21.5V3.5C22.5 1.85938 21.1406 0.5 19.5 0.5ZM5.25 21.5V20H6.375C6.98438 20 7.5 19.5312 7.5 18.875C7.5 18.2656 6.98438 17.75 6.375 17.75H5.25V13.625H6.375C6.98438 13.625 7.5 13.1562 7.5 12.5C7.5 11.8906 6.98438 11.375 6.375 11.375H5.25V7.25H6.375C6.98438 7.25 7.5 6.78125 7.5 6.125C7.5 5.51562 6.98438 5 6.375 5H5.25V3.5C5.25 3.125 5.57812 2.75 6 2.75H9V22.25H6C5.57812 22.25 5.25 21.9219 5.25 21.5ZM20.25 21.5C20.25 21.9219 19.875 22.25 19.5 22.25H11.25V2.75H19.5C19.875 2.75 20.25 3.125 20.25 3.5V21.5Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebook);
export default __webpack_public_path__ + "static/media/notebook.2945b272.svg";
export { ForwardRef as ReactComponent };